import Flex, { FlexProps } from './Flex';

export default Flex;
export type { FlexProps };
